import { InjectionToken } from '@angular/core';

/** Todo texto fixo do runner. Sobrescreva parcialmente por `AI_RUNNER_LABELS` ou `config.labels`. */
export interface AiRunnerLabels {
  help: string;
  pipeline: string;
  selectPipeline: string;
  select: string;
  loadingOptions: string;
  send: string;
  readyToRun: string;
  sent: string;
  processing: string;
  result: string;
  notInformed: string;
  copy: string;
  viewRaw: string;
  viewFormatted: string;
  applySection: string;
  applied: string;
  saving: string;
  done: string;
  error: string;
  attachFiles: string;
  maxFileSize: (mb: number) => string;
  remove: string;
  close: string;
  cancelRun: string;
  run: string;
  apply: string;
  again: string;
  denied: string;
  modelUnavailable: string;
  loadPipelinesError: string;
  runNotFinished: string;
  runCancelled: string;
  runFailed: string;
  startError: string;
  cancelError: string;
  applyError: string;
  finishError: string;
  /** Execução em andamento que bloqueou o disparo: botão para acompanhá-la. */
  followRun: string;
  editContent: string;
  closeEdit: string;
  /** Prefixo do `aria-label` do editor de conteúdo de uma ação. */
  editAction: string;
  /** Rodapé: abre a lista de resultados anteriores (com a contagem). */
  history: string;
  /** Título da lista quando o modal é só consulta (sem permissão de executar). */
  historyReadOnly: string;
  historyEmpty: string;
  closeList: string;
  /** Nome da execução quando a pipeline dela não é conhecida. */
  unknownRun: string;
  statusPending: string;
  statusRunning: string;
  statusCompleted: string;
  statusFailed: string;
  statusCancelled: string;
}

export const AI_RUNNER_DEFAULT_LABELS: AiRunnerLabels = {
  help: 'Ajuda',
  pipeline: 'Pipeline',
  selectPipeline: 'Selecione a pipeline',
  select: 'Selecione',
  loadingOptions: 'Carregando opções…',
  send: 'Enviar',
  readyToRun: 'Pronto para executar.',
  sent: 'Enviado',
  processing: 'Processando…',
  result: 'Resultado',
  notInformed: 'não informado',
  copy: 'Copiar',
  viewRaw: 'Ver bruto',
  viewFormatted: 'Ver formatado',
  applySection: 'Atualizar na tela',
  applied: 'Valores aplicados.',
  saving: 'Gravando',
  done: 'Concluído',
  error: 'Erro',
  attachFiles: 'Anexar arquivos',
  maxFileSize: mb => `Até ${mb} MB cada`,
  remove: 'Remover',
  close: 'Fechar',
  cancelRun: 'Cancelar execução',
  run: 'Executar',
  apply: 'Aplicar na tela',
  again: 'Nova execução',
  denied: 'Você não tem permissão para executar esta ação.',
  modelUnavailable: 'Chamar um modelo diretamente, sem pipeline, ainda não é suportado pela API.',
  loadPipelinesError: 'Não foi possível carregar as pipelines.',
  runNotFinished: 'A execução não terminou.',
  runCancelled: 'Execução cancelada.',
  runFailed: 'A execução falhou.',
  startError: 'Não foi possível iniciar a execução.',
  cancelError: 'Não foi possível cancelar.',
  applyError: 'Não foi possível aplicar o resultado.',
  finishError: 'Não foi possível concluir.',
  followRun: 'Acompanhar execução em andamento',
  editContent: 'Editar conteúdo',
  closeEdit: 'Fechar edição',
  editAction: 'Editar',
  history: 'Resultados anteriores',
  historyReadOnly: 'Resultados',
  historyEmpty: 'Nenhum resultado disponível.',
  closeList: 'Fechar lista',
  unknownRun: 'Execução',
  statusPending: 'Na fila',
  statusRunning: 'Em andamento',
  statusCompleted: 'Concluída',
  statusFailed: 'Falhou',
  statusCancelled: 'Cancelada',
};

export const AI_RUNNER_LABELS = new InjectionToken<Partial<AiRunnerLabels>>('AI_RUNNER_LABELS', {
  providedIn: 'root',
  factory: () => ({}),
});

/** Valores padrão do comportamento; `config` sempre vence. */
export interface AiRunnerDefaults {
  icon: string;
  width: string;
  chatWidth: string;
  maxFileMb: number;
  pollFallbackMs: number;
}

export const AI_RUNNER_DEFAULTS_VALUE: AiRunnerDefaults = {
  icon: 'pi pi-sparkles',
  width: '46rem',
  chatWidth: '52rem',
  maxFileMb: 5,
  pollFallbackMs: 10000,
};

export const AI_RUNNER_DEFAULTS = new InjectionToken<Partial<AiRunnerDefaults>>(
  'AI_RUNNER_DEFAULTS',
  { providedIn: 'root', factory: () => ({}) }
);
